module.exports = __webpack_public_path__ + "static/img/01.8197a586.png";